<template>
  <div>
    <div class="page-title">
      <h3>{{'profile' | langFilter}}</h3>
    </div>

    <form class="form" @submit.prevent="submitForm">
      <div class="input-field">
        <input
          id="description"
          type="text"
          v-model="name"
          :class="{'invalid': $v.name.$dirty && $v.name.$invalid}"
        />
        <label for="description">{{'name' | langFilter}}</label>
        <span class="helper-text invalid" v-if="$v.name.$dirty && !$v.name.required">Введите имя</span>
      </div>
      <div class="switch">
        <label>
          English
          <input type="checkbox" v-model="isRus" />
          <span class="lever"></span>
          Русский
        </label>
      </div>
      <button class="btn waves-effect waves-light" type="submit">
        {{'refresh' | langFilter}}
        <i class="material-icons right">send</i>
      </button>
    </form>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";

export default {
  metaInfo(){
    return {
      title: this.$title('profile')
    }
  },
  data: () => ({
    name: "",
    isRus: true
  }),
  async mounted() {
    const lang = this.$store.getters.info.lang;
    this.isRus = lang === "ru-RU";
    this.name = this.$store.getters.info.name;
    setTimeout(() => {
      M.updateTextFields();
    }, 0);
  },
  methods: {
    async submitForm() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }
      try {
        await this.$store.dispatch("updateBill", {
          name: this.name,
          lang: this.isRus ? "ru-RU" : "en-US"
        });
      } catch (e) {}
    }
  },
  validations: {
    name: { required }
  }
};
</script>

<style>
.switch {
  margin-bottom: 20px;
}
</style>
